import { render, staticRenderFns } from "./ElCollapsable.vue?vue&type=template&id=f92e94a4"
import script from "./ElCollapsable.vue?vue&type=script&lang=js"
export * from "./ElCollapsable.vue?vue&type=script&lang=js"
import style0 from "./ElCollapsable.vue?vue&type=style&index=0&id=f92e94a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports